import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared';

/* 3rd party */
import { ModalModule } from 'ngx-bootstrap/modal';
import { Angulartics2Module } from 'angulartics2';

/* Routes */
import { AuthRoutes } from './auth.routes';

@NgModule({
  imports: [CommonModule, SharedModule, ModalModule, RouterModule.forChild(AuthRoutes), Angulartics2Module],
  declarations: [],
  providers: []
})
export class AuthModule {
  constructor() {}
}
